var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.85 18.73 14.15 12A6 6 0 1 0 12 14.15l6.7 6.7a.5.5 0 0 0 .71 0l1.41-1.41a.5.5 0 0 0 .03-.71ZM9 12a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
})));
export default SvgSearch;